import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { format } from 'date-fns';
import moment from 'moment';
import { CommonListQuery, } from '../../../../redux/api/apiTypes';
import { ReportParams, EmplItem } from './apiTypes';

export const emplReportApi = createApi({
    reducerPath: 'emplReportApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/api/v1/reports",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getEmplReport: builder.query<EmplItem[], { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/time-work/search`,
                method: 'GET',
                params: {
                    page_size: body.size || 10,
                    page_number: body.page || 0,
                    sort_type: 1,
                    accounts: body?.searchParam?.accounts,
                    from_date: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    to_date: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                }
            }),
            transformResponse: (response: { data: EmplItem[] }, meta, arg) => {
                return response.data;
            },
        }),
        getEmplReportTotal: builder.query<number, { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/time-work/records/amount`,
                method: 'GET',
                params: {
                    accounts: body?.searchParam?.accounts,
                    from_date: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    to_date: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                }
            }),
            transformResponse: (response: { data: number }, meta, arg) => {
                return response.data;
            },
        }),
        exportData: builder.mutation<any, { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/time-work/export`,
                method: 'GET',
                params: {
                    sort_type: 1,
                    accounts: body?.searchParam?.accounts,
                    from_date: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    to_date: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                },
                responseHandler: async (response) => {
                    let filename = `${format(new Date(), "dd-MM-yyyy")}_Báo cáo thời gian làm việc.xlsx`;
                    let blob = await response.blob();
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename);
                    link.click();
                },
                cache: "no-cache",
            }),
        }),
    })
})

export const {
    useLazyGetEmplReportQuery,
    useLazyGetEmplReportTotalQuery,
    useExportDataMutation,
} = emplReportApi;

export default emplReportApi;